import Home from '../views/Home.vue'
import Properties from '../views/properties/Properties.vue'
import AddProperty from '../views/properties/AddProperty.vue'
import PropertySingle from '../views/properties/PropertySingle.vue'
import Property from '../views/properties/Property.vue'
import Contracts from '../views/Contracts'
import ContractType from '../views/contracts/ContractType.vue'
import PropertySelector from '../views/legacy-contracts/PropertySelector.vue'
import AddContract from '../views/legacy-contracts/AddContract.vue'
import Screenings from '../views/Screenings.vue'
import Invitations from '../views/Invitations.vue'
import Login from '../views/auth/Login.vue'
import Register from '../views/auth/Register.vue'
import ForgotPassword from '../views/auth/ForgotPassword.vue';
import ChangePassword from '../views/auth/ChangePassword.vue';
import TenantScreeningRegister from '../views/auth/TenantScreeningRegister.vue';
import TenantContractRegister from '../views/auth/TenantContractRegister.vue'
import Companies from '../views/companies/Companies.vue';
import AddCompany from '../views/companies/AddCompany.vue';
import ScreeningInfo from '../views/screenings/ScreeningInfo.vue';
import AddScreening from '../views/screenings/AddScreening.vue';
import ScreeningFinalize from '../views/screenings/ScreeningFinalize.vue';
import SelectProperty from '../views/screenings/SelectProperty.vue';
import UserSettings from '../views/user/UserSettings.vue';
import SettingsChangePassword from '../views/user/ChangePassword.vue';
import DigitalContractConfirm from '../views/digital-contract/DigitalContractConfirm.vue';
import DigitalContractApproval from '../views/digital-contract/DigitalContractApprove.vue';
import DigitalContractFinalized from '../views/digital-contract/DigitalContractFinalized.vue';
import DigitalContractStatus from '../views/digital-contract/DigitalContractStatus.vue';
import DigitalContractView from "../views/digital-contract/DigitalContractView";
import Billings from '../views/user/Billings.vue';
import Checkout from '../views/Checkout';
import SelectPlan from '../views/SelectPlan';
import Receipt from '../views/Receipt';

import ContractStatus from '../views/contracts/ContractStatus';

import NoBrowserSupport from '../views/BrowserNoSupport';

import PricingBoxes from '../views/PricingBoxes';

import Clients from '../views/clients/Clients.vue';

import DigitalContractPS from '../views/digital-contract/PropertySelector';
import DigitalContractWizard from '../views/digital-contract/DigitalContractWizard';
import DigitalContractStartSignature from '../views/digital-contract/DigitalContractStartSignature';

import TenantScreening from '../views/tenant/TenantScreening.vue';
import TenantScreeningSuccess from '../views/tenant/TenantScreeningSuccess.vue';
import TenantProfile from '../views/tenant/TenantProfile.vue';

import NotScreenedSigning from '../views/signing/NotScreened.vue';
import SigningReview from '../views/signing/Review.vue';
import Signing from '../views/signing/Signing.vue';
import SigningSuccess from '../views/signing/Success.vue';
import PowerSupply from '../views/signing/PowerSupply.vue';

import EmailTemplate from '../views/EmailTemplate.vue';
import EmailTemplateEditor from '../views/EmailTemplateEditor.vue';

import CustomContractWizzard from "../views/custom-contracts/Wizzard/CustomContractWizzard";
import CustomContractPropertySelect from "../views/custom-contracts/CustomContractPropertySelect";
import CustomContractView from "../views/custom-contracts/CustomContractView";
import CustomContractSign from "../views/custom-contracts/Signing/CustomContractSign";
import CustomContractStatusDashboard from "../views/custom-contracts/CustomContractStatusDashboard";

export const routes = [
    {path: '/', component: Home, meta: {requiresAuth: true}},
    {path: '/properties', component: Properties, meta: {requiresAuth: true, landlordOnly: true}},
    {path: '/properties/add', component: AddProperty, meta: {requiresAuth: true, landlordOnly: true}},
    {path: '/properties/:id', component: PropertySingle, meta: {requiresAuth: true, landlordOnly: true}, props: true},
    {
        path: '/properties/property/:id',
        component: Property,
        meta: {requiresAuth: true, landlordOnly: true},
        props: true
    },
    {path: '/contracts', component: Contracts, meta: {requiresAuth: true}, name: 'contracts'},
    {
        path: '/contracts/select-property',
        component: PropertySelector,
        meta: {requiresAuth: true, landlordOnly: true, requiresLegacyContract: true}
    },
    {
        path: '/contracts/add',
        component: AddContract,
        meta: {requiresAuth: true, landlordOnly: true, requiresLegacyContract: true}
    },
    {
        path: '/contracts/digital-contract/:id/approve',
        component: DigitalContractApproval,
        meta: {requiresAuth: true}
    },

    {path: '/contracts/choose-type', component: ContractType, meta: {requiresAuth: true, landlordOnly: true}},
    {path: '/contracts/contract-status', component: ContractStatus, meta: {requiresAuth: true, landlordOnly: true}},

    {path: '/clients', component: Clients, meta: {requiresAuth: true, landlordOnly: true}},

    {path: '/companies', component: Companies, meta: {requiresAuth: true, landlordOnly: true}},
    {path: '/companies/add', component: AddCompany, meta: {requiresAuth: true, landlordOnly: true}},
    {path: '/screenings', component: Screenings, meta: {requiresAuth: true, landlordOnly: true}},
    {path: '/invitations', component: Invitations, meta: {requiresAuth: true, tenantOnly: true}},

    {path: '/login', component: Login},
    {path: '/login/:hash', component: Login, props: true},
    {path: '/register', component: Register, props: true},
    {path: '/register/:hash', component: Register, props: true},

    {path: '/screening-register', component: TenantScreeningRegister, props: true},
    {path: '/contract-register', component: TenantContractRegister, props: true},
    {path: '/forgot-password', component: ForgotPassword},
    {path: '/change-password/:hash', component: ChangePassword, props: true, meta: {requiresAuth: false}},
    {path: '/screenings/info', component: ScreeningInfo, meta: {requiresAuth: true}},
    {path: '/screenings/add', component: AddScreening, meta: {requiresAuth: true}},
    {path: '/screenings/:id/send', component: ScreeningFinalize, meta: {requiresAuth: true}},
    {path: '/screenings/select-property', component: SelectProperty, meta: {requiresAuth: true}},
    {path: '/user/settings', component: UserSettings, meta: {requiresAuth: true}},
    {path: '/user/change-password', component: SettingsChangePassword, meta: {requiresAuth: true}},
    {path: '/user/billings', component: Billings, meta: {requiresAuth: true}},
    {path: '/select-plan', component: SelectPlan},
    {path: '/receipt/:style/:id', component: Receipt},

    {path: '/pricing', component: PricingBoxes},

    {path: '/tenant-screening', component: TenantScreening, meta: {requiresAuth: true, tenantOnly: true}},
    {
        path: '/tenant-screening-success',
        component: TenantScreeningSuccess,
        meta: {requiresAuth: true, tenantOnly: true}
    },
    {path: '/tenant-profile/:id', component: TenantProfile, meta: {requiresAuth: true}},
    {path: '/screenings/tenant-profile/:id', component: TenantProfile, meta: {requiresAuth: true}},
    {path: '/my-profile', component: TenantProfile, meta: {requiresAuth: true, tenantOnly: true}},

    {path: '/screening-info/:id', component: NotScreenedSigning, meta: {requiresAuth: true}},
    {path: '/signing-review/:id', component: SigningReview, meta: {requiresAuth: true}},
    {path: '/signing-el/:id',component:PowerSupply, meta:{requiresAuth: true}},
    {path: '/signing/:id', component: Signing, meta: {requiresAuth: true}},
    {path: '/signing-success', component: SigningSuccess, meta: {requiresAuth: true}},

    {path: '/checkout/complete', component: Checkout},

    {path: '/email-template', component: EmailTemplate},
    {path: '/email-template/:id', component: EmailTemplateEditor},

    {path: '/no-support', component: NoBrowserSupport, meta: {id: 'NoSupport'}},

    /* Draft Contracts */
    {
        path: '/contracts/digital-contract/status/:id',
        component: DigitalContractStatus,
        meta: {requiresAuth: true, landlordOnly: true}
    },
    {
        path: '/contracts/digital-contract/select-property',
        component: DigitalContractPS,
        meta: {requiresAuth: true, landlordOnly: true}
    },
    {
        path: '/contracts/digital-contract/create',
        component: DigitalContractWizard,
        meta: {requiresAuth: true, landlordOnly: true}
    },
    {
        path: '/contracts/digital-contract/download/:id',
        component: DigitalContractFinalized,
        meta: {requiresAuth: true}
    },
    {
        path: '/contracts/digital-contract/:id/download',
        component: DigitalContractFinalized,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/contracts/digital-contract/edit/:id',
        component: DigitalContractWizard,
        meta: {
            requiresAuth: true,
            landlordOnly: true
        },
        props: true
    },
    {
        path: '/contracts/digital-contract/:id',
        component: DigitalContractView,
        meta: {
            requiresAuth: true,
        },
        props: true
    },
    {
        path: '/contracts/digital-contract/confirm/:id',
        component: DigitalContractConfirm,
        meta: {
            requiresAuth: true,
            landlordOnly: true
        },
        props: true
    },
    {
        path: '/contracts/contract/:id/start-signature',
        component: DigitalContractStartSignature,
        meta: {
            requiresAuth: false
        },
        props: true
    },
    /* Custom Contracts */
    {
        path: '/custom-contract/select-property',
        component: CustomContractPropertySelect,
        meta: {
            requiresAuth: true,
            landlordOnly: true
        },
        name: 'custom-contract::select-property'
    },
    {
        path: '/custom-contract/create',
        component: CustomContractWizzard,
        meta: {
            requiresAuth: true,
            landlordOnly: true
        },
        props: true,
        name: 'custom-contract::create'
    },
    {
        path: '/custom-contract/edit/:id',
        component: CustomContractWizzard,
        meta: {
            requiresAuth: true,
            landlordOnly: true
        },
        name: 'custom-contract::edit'
    },
    {
        path: '/custom-contract/:id',
        component: CustomContractView,
        meta: {
            requiresAuth: true
        },
        props: true,
        name: 'custom-contract::view'
    },
    {
        path: '/custom-contract/:id/sign',
        component: CustomContractSign,
        meta: {
            requiresAuth: true
        },
        name: 'custom-contract::sign'
    },
    {
        path: '/custom-contract/:id/status',
        component: CustomContractStatusDashboard,
        meta: {
            requiresAuth: true
        },
        props: true,
        name: 'custom-contract::status'
    },
];
